import { Column, CreateDateColumn, Entity, Index, PrimaryGeneratedColumn, UpdateDateColumn, VersionColumn } from "typeorm";
import { ReferenceFeatures } from "@gtpl/shared-models/common-models";

@Entity('_common_file_upload')
@Index('FILES_COMMON_QUERY', ['featuresRefName', 'featuresRefNo'])
export class FileUploadEntity {
    @PrimaryGeneratedColumn({
        name: 'id'
    })
    public id: number;

    @Column('varchar', {
        nullable: false,
        length: 250,
        name: 'file_description'
    })
    fileDescription: string;

    @Column('varchar', {
        nullable: false,
        name: 'features_ref_no'
    })
    featuresRefNo: any;

    @Column({
        type: 'enum',
        enum: ReferenceFeatures,
        nullable: false,
        name: 'features_ref_name'
    })
    featuresRefName: ReferenceFeatures;

    @Column('varchar', {
        nullable: false,
        length: 250,
        name: 'file_name'
    })
    fileName: string;

    @Column('integer', {
        nullable: true,
        name: 'size',
        default: 1
    })
    size: string;

    @Column('varchar', {
        nullable: false,
        length: 250,
        name: 'original_name'
    })
    originalName: string;

    // @Column('varchar', {
    //     nullable: false,
    //     length: 100,
    //     name: 'image_type'
    // })
    // imageType: ImageTypeEnum

    @Column('varchar', {
        nullable: false,
        length: 300,
        name: 'file_path'
    })
    filePath: string;
    
    @Column('boolean', {
        nullable: false,
        default: true,
        name: 'is_active',
    })
    isActive: boolean;

    @CreateDateColumn({ name: 'created_at' })
    createdAt: Date;


    @Column('varchar', {
        nullable: true,
        length: 40,
        name: 'created_user'
    })
    createdUser: string | null;

    @UpdateDateColumn({ name: 'updated_at' })
    updatedAt: Date;


    @Column('varchar', {
        nullable: true,
        length: 40,
        name: 'updated_user'
    })
    updatedUser: string | null;


    @VersionColumn({
        default: 1,
        name: 'version_flag'
    })
    versionFlag: number;
}